const KEY = "kirana_memories_v1";

export const getMemories = () => {
  try {
    return JSON.parse(localStorage.getItem(KEY)) || [];
  } catch {
    return [];
  }
};

export const addMemory = (id) => {
  const m = getMemories();
  if (!m.includes(id)) {
    m.push(id);
    localStorage.setItem(KEY, JSON.stringify(m));
  }
  return [...m];
};

export const clearMemories = () => {
  localStorage.removeItem(KEY);
};

const GKEY = "mohalla_memories_v1";

export const getGameMemories = () => {
  try {
    return JSON.parse(localStorage.getItem(GKEY)) || [];
  } catch {
    return [];
  }
};

export const addGameMemory = (id) => {
  const m = getGameMemories();
  if (!m.includes(id)) {
    m.push(id);
    localStorage.setItem(GKEY, JSON.stringify(m));
  }
  return [...m];
};

const SKEY = "school_memories_v1";

export const getSchoolMemories = () => {
  try {
    return JSON.parse(localStorage.getItem(SKEY)) || [];
  } catch {
    return [];
  }
};

export const addSchoolMemory = (id) => {
  const m = getSchoolMemories();
  if (!m.includes(id)) {
    m.push(id);
    localStorage.setItem(SKEY, JSON.stringify(m));
  }
  return [...m];
};

const TKEY = "tv_memories_v1";

export const getTvMemories = () => {
  try {
    return JSON.parse(localStorage.getItem(TKEY)) || [];
  } catch {
    return [];
  }
};

export const addTvMemory = (id) => {
  const m = getTvMemories();
  if (!m.includes(id)) {
    m.push(id);
    localStorage.setItem(TKEY, JSON.stringify(m));
  }
  return [...m];
};

const OKEY = "mohalla_objects_v1";

export const getObjectMemories = () => {
  try {
    return JSON.parse(localStorage.getItem(OKEY)) || [];
  } catch {
    return [];
  }
};

export const addObjectMemory = (id) => {
  const m = getObjectMemories();
  if (!m.includes(id)) {
    m.push(id);
    localStorage.setItem(OKEY, JSON.stringify(m));
  }
  return [...m];
};
